export const models = {
    sourceLanguage: 'HIGH',
    translation: 'HIGH',
    chat: 'HIGH',
    fallback: 'HIGH',
    stt: 'general',
};
